@if (containersData$ | async; as containers) {
  @if (containers?.length > 0) {
    <div class="card-p">
      <div class="heading">
        @if (compData?.container?.title) {
          <h2 class="slider-heading">
            {{ compData?.container?.title | titlecase }}
          </h2>
        }
      </div>
      <div class="parent">
        @for (container of containers; track container; let index = $index) {
          <div class="child">
            <div class="small-img-card"
                 appIntersectionObserver
                 [intersectionDebounce]="0"
                 (visibilityChange)="onVisibilityChanged($event)"
                 (click)="onCardClick(container)"
            >
              @if (container?.seoNavigationUrl) {
                <a class="card"
                   href="{{ hostWebsite + container?.seoNavigationUrl }}"
                   [target]="target"
                   onclick="return false;"
                >
                  <ng-container *ngTemplateOutlet="productTemplate; context: { container: container }"></ng-container>
                </a>
              } @else {
                <a class="card"
                   href="javascript:void(0)"
                   [target]="target"
                >
                  <ng-container *ngTemplateOutlet="productTemplate; context: { container: container }"></ng-container>
                </a>
              }

            </div>
            @if (container?.hotelListSchema && container?.hotelListSchema?.url) {
              <div class="hidden">
                <div itemscope="" itemtype="http://schema.org/Hotel">
                  <span itemprop="name">{{ container?.hotelListSchema?.name }}</span>
                  @if (container?.ratingAndReviewConfig?.rating > 0) {
                    <div itemprop="aggregateRating"
                         itemscope=""
                         itemtype="http://schema.org/AggregateRating"
                    >
                      <meta itemprop="ratingValue"
                            content="{{container?.ratingAndReviewConfig?.rating}}"/>
                      <meta itemprop="worstRating" content="1"/>
                      <meta itemprop="reviewCount"
                            content="{{
          container?.ratingAndReviewConfig?.votes
        }}"
                      />
                      <meta itemprop="bestRating" content="5"/>
                    </div>
                  }
                  <div
                    itemprop="address"
                    itemscope=""
                    itemtype="http://schema.org/PostalAddress"
                  >
                          <span itemprop="addressLocality">
                            {{ container?.hotelListSchema?.address?.addressLocality }}
                          </span>
                    <span itemprop="addressRegion">{{
                        container?.hotelListSchema?.address?.addressRegion
                      }}</span>
                    <span itemprop="addressCountry">{{
                        container?.hotelListSchema?.address?.addressCountry
                      }}</span>
                    <span itemprop="streetAddress">{{
                        container?.hotelListSchema?.address?.streetAddress
                      }}</span>
                    <span itemprop="postalCode">{{ container?.hotelListSchema?.address?.postalCode }}</span>
                  </div>
                  <meta
                    itemprop="priceRange"
                    content="{{ container?.hotelListSchema?.priceRange }}"
                  />
                  <meta
                    itemprop="telephone"
                    content="{{ container?.hotelListSchema?.telephone }}"
                  />
                  <meta
                    itemprop="url"
                    content="{{ container?.hotelListSchema?.url }}"
                  />
                  <meta
                    itemprop="email"
                    content="{{ container?.hotelListSchema?.email }}"
                  />
                  <meta
                    itemprop="image"
                    content="{{ container?.hotelListSchema?.image }}"
                  />
                  <div
                    itemprop="geo"
                    itemscope=""
                    itemtype="http://schema.org/GeoCoordinates"
                  >
                    <meta
                      itemprop="latitude"
                      content="{{ container?.hotelListSchema?.geo?.latitude }}"
                    />
                    <meta
                      itemprop="longitude"
                      content="{{ container?.hotelListSchema?.geo?.longitude }}"
                    />
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    <ng-template #productTemplate let-container="container">
      <div class="property-card">
        <div class="img-wrap">
          <div class="property-img">
            <img
              width="146"
              height="95"
              [ngSrc]="container?.image?.path  + '?format=webp&quality=90&height=95'"
              alt="{{ container?.image?.alt }}"
              #image
              (error)="image.src = placeHolderImage + '?format=webp&quality=80&height=95'"
            />
          </div>
        </div>
        <div>
          <div class="property-name">
            {{ container?.displayName }}
          </div>
          <div>
            <div class="stars-section">
              <div class="review-wrap">
                <div class="rating-container">
                  @if (container?.starRatingConfig?.filledStars?.length > 0) {
                    <div
                      class="flex-container ion-align-items-center r-gp">
                      @for (star of container?.starRatingConfig?.filledStars; track star) {
                        ★
                      }
                    </div>
                  }
                  @if (container?.ratingAndReviewConfig?.rating > 0) {
                    <div class="rating">
                                  <span
                                    class="rating-point">{{ container?.ratingAndReviewConfig?.rating | number: '1.1-1' }}
                                  </span>
                    </div>
                    <div class="votes-count">
                      @if (container?.ratingAndReviewConfig?.votes > 0) {
                        <span>
                                      ({{ container?.ratingAndReviewConfig?.votes + ' ' + container?.ratingAndReviewConfig?.sRatingLabel }}
                          )
                                    </span>
                      }
                    </div>
                  }
                </div>
                <div class="discounted-price-section">
                  <div class="og-price">
                    @if (!container?.priceData?.notAvailableForGivenHour) {
                      @if (container?.priceData?.lineThroughPrice| isNotEmpty) {
                        <div>
                                      <span class="line-through org-price">
                                        <span>{{ container?.priceData?.currencySymbol }}</span>
                                        <span>{{ container?.priceData?.lineThroughPrice }}</span>
                                      </span>
                        </div>
                      }
                      <div class="final-price">
                                    <span class="">
                                      <span>{{ container?.priceData?.currencySymbol }}</span>
                                      <span>{{ container?.priceData?.price }}</span>
                                    </span>
                      </div>
                      <div class="for-hours">{{ container?.priceData?.info }}</div>
                    }
                    @if (container?.priceData?.notAvailableForGivenHour) {
                      <div class="err-card">
                        <div class="err-price">{{ container?.priceData?.price }}</div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  }
}
